import React, { useEffect, useState } from 'react';
import useStore from 'state/state';
import clsx from 'clsx';
import styles from './BottomMenu.module.scss';
import MenuButton from './MenuButton/MenuButton';
import RightSideButtons from './RightButtons/RightSideButtons';

const BottomMenu = () => {
  const appData = useStore((state) => state.appData);

  const productObject = useStore((state) => state.productObject);
  const setProductObject = useStore((state) => state.setProductObject);
  const setIsMapOpen = useStore((state) => state.setIsMapOpen);
  const setIsOverviewMapOpen = useStore((state) => state.setIsOverviewMapOpen);
  const isWhitePaperOpen = useStore((state) => state.isWhitePaperOpen);
  const isArticleOpen = useStore((state) => state.isArticleOpen);
  const isGalleryOpen = useStore((state) => state.isGalleryOpen);
  const isOffline = useStore((state) => state.isOffline);

  const setProductData = useStore((state) => state.setProductData);
  const setIsShareOpen = useStore((state) => state.setIsShareOpen);

  const setIsAboutOpen = useStore((state) => state.setIsAboutOpen);

  const setIsOnboardingOpen = useStore((state) => state.setIsOnboardingOpen);
  const mode = useStore((state) => state.mode);
  const isOverviewMapOpen = useStore((state) => state.isOverviewMapOpen);
  const roomId = useStore((state) => state.roomId);

  const [showRightButtons, setShowRightButtons] = useState(false);

  const [showCurrentRoomButtons, setShowCurrentRoomButtons] = useState(true);
  const [showHomeButtons, setShowHomeButtons] = useState(true);
  const [locJP, setLocJP] = useState(false);

  const [roomName, setRoomName] = useState(null);

  const showAbout = !isOffline && !!appData.mainData.aboutUs;
  useEffect(() => {
    const lang = document.querySelector('meta[name="geo.region"]');
    if (lang) {
      if (lang.content.toLowerCase() === 'jp') {
        setLocJP(true);
      }
    }
  }, []);
  useEffect(() => {
    if (mode === 'modeOverview') {
      setIsOverviewMapOpen(false);
      setShowCurrentRoomButtons(false);
      setShowHomeButtons(false);
    }

    if (mode === 'modeRoomOverview') {
      setIsMapOpen(false);
      setShowCurrentRoomButtons(false);
      setShowHomeButtons(true);
    }

    if (mode === 'modeFloor') {
      setShowRightButtons(true);
    } else {
      setShowRightButtons(false);
    }

    if (
      isWhitePaperOpen ||
      isArticleOpen ||
      isGalleryOpen ||
      mode === 'modeIntro'
    ) {
      setShowCurrentRoomButtons(false);
      setShowHomeButtons(false);
    }

    if (
      mode !== 'modeRoomOverview' &&
      mode !== 'modeOverview' &&
      mode !== 'modeIntro'
    ) {
      if (!isWhitePaperOpen && !isArticleOpen && !isGalleryOpen) {
        setShowCurrentRoomButtons(true);
        setShowHomeButtons(true);
      }
    }
  }, [
    isArticleOpen,
    isGalleryOpen,
    isOverviewMapOpen,
    isWhitePaperOpen,
    mode,
    setIsMapOpen,
    setIsOverviewMapOpen,
    setIsAboutOpen,
    showCurrentRoomButtons,
    showHomeButtons,
    showRightButtons,
  ]);

  /*
  useEffect(() => {
    console.log('isOffline ', isOffline);
    console.log('aboutUs ', appData.mainData.aboutUs);
    console.log('show ', showAbout);
  }, []);
  */

  useEffect(() => {
    const rooms = [
      appData.mainData.rooms.roomATitle,
      appData.mainData.rooms.roomBTitle,
      appData.mainData.rooms.roomCTitle,
      appData.mainData.rooms.roomDTitle,
      appData.mainData.rooms.roomETitle,
    ];
    setRoomName(rooms[roomId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomId]);

  const onHomeClick = () => {
    setIsMapOpen(true);
    setProductObject(null);
    setProductData(null);
  };

  const onMapClick = () => {
    setIsOverviewMapOpen(true);
    setProductObject(null);
    setProductData(null);
  };

  const onAboutClick = () => {
    setIsAboutOpen(true);
  };

  const onHelpClick = () => {
    setIsOnboardingOpen(true);
  };

  const onShareClick = () => {
    setIsShareOpen(true);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <div
          className={clsx(styles.button, { [styles.visible]: showHomeButtons })}
        >
          <MenuButton
            icon="home"
            alignLeft
            onClick={onHomeClick}
            radiusBoth={!showCurrentRoomButtons}
          />
        </div>
        <div
          className={clsx(styles.button, {
            [styles.visible]: showCurrentRoomButtons,
          })}
        >
          <MenuButton
            icon="map"
            label={roomName}
            alignRight
            onClick={onMapClick}
          />
        </div>
      </div>
      <div className={styles.right}>
        <div
          className={clsx(styles.buttonLarge, {
            [styles.visible]: showRightButtons && !productObject,
          })}
        >
          <RightSideButtons
            onAboutClick={onAboutClick}
            onHelpClick={onHelpClick}
            onShareClick={onShareClick}
            showAbout={showAbout}
            shareText={appData.mainData.overallApp.tooltips.share}
            helpText={appData.mainData.overallApp.tooltips.help}
            aboutUsText={appData.mainData.overallApp.tooltips.aboutUs}
            locJP={locJP}
          />
        </div>
      </div>
    </div>
  );
};

export default BottomMenu;
